import * as constants from "./constants";

const initialState = {
  allMaterialTypes: [],
  allBoltTypes: [],
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
};

const materialTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CREATE_MATERIAL_TYPES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.CREATE_MATERIAL_TYPES_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allMaterialTypes: [...state.allMaterialTypes, action.data],
        isAdding: false,
      };
    case constants.CREATE_MATERIAL_TYPES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_MATERIAL_TYPES_ORDER:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.UPDATE_MATERIAL_TYPES_ORDER_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allMaterialTypes: action.data,
      };
    case constants.UPDATE_MATERIAL_TYPES_ORDER_ERROR:
      return {
        ...state,
        fetchingLoading: false,
      };
    case constants.FETCH_BOLT_TYPES:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_BOLT_TYPES_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allBoltTypes: action.data,
        isAdding: false,
      };
    case constants.FETCH_BOLT_TYPES_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };

    case constants.FETCH_MATERIAL_TYPES:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_MATERIAL_TYPES_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allMaterialTypes: action.data,
        isAdding: false,
      };
    case constants.FETCH_MATERIAL_TYPES_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_MATERIAL_TYPES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_MATERIAL_TYPES_SUCCESS:
      const updated = state.allMaterialTypes.map((el) =>
        el.id === action.data.id ? { ...el, ...action.data } : el
      );
      return {
        ...state,
        allMaterialTypes: updated,
        updateLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_MATERIAL_TYPES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_MATERIAL_TYPES:
      return {
        ...state,
        updateLoading: true,
        isAdding: false,
      };
    case constants.DELETE_MATERIAL_TYPES_SUCCESS:
      const updatedData = state.allMaterialTypes.filter(
        (el) => el.id !== action.data
      );
      return {
        ...state,
        allMaterialTypes: updatedData,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_MATERIAL_TYPES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };

    default:
      return state;
  }
};

export default materialTypesReducer;
